module.exports = __webpack_public_path__ + "static/img/password.41628c14.png";